import { useContext } from "react";
import { Activity, CalendarDays } from "lucide-react";
import { DataResume, GraphicDailySales, GraphicOrderbump, GraphicProductMain } from ".";
import { SidebarContext } from "../../../shared/context/SidebarContext";
import { DashboardContext } from "../context/DashboardContext";

const fmtPeriodo = (start, end) => {
    if (!start || !end) return "";
    const fmt = (s) => {
        const [y, m, d] = s.split("-");
        return `${d}/${m}/${y.slice(2)}`;
    };
    return `${fmt(start)} → ${fmt(end)}`;
};

export default function Main() {

    const { isOpen } = useContext(SidebarContext);
    const { dateRange, setDateRange, data } = useContext(DashboardContext);

    const handleDateChange = (field, value) => {
        setDateRange(prev => ({ ...prev, [field]: value }));
    };

    const periodoAnterior = data?.anterior?.periodo;

    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>

                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">

                    {/* HEADER */}
                    <header className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 animate-fade-in">
                        <div className="space-y-1">
                            <div className="flex items-center gap-2">
                                <span className="label-overline text-ink-4">Período</span>
                                <span className="text-xs text-ink-3 tabular-nums">{fmtPeriodo(dateRange.start, dateRange.end)}</span>
                            </div>
                            <h1 className="display-2 flex items-center gap-3">
                                Dashboard
                                <Activity className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
                            </h1>
                            <p className="text-ink-3 text-sm">
                                Vendas, ROI e performance no período selecionado.
                                {periodoAnterior && (
                                    <span className="text-ink-4">
                                        {" "}As variações ↑↓ comparam com{" "}
                                        <span className="tabular-nums text-ink-3">{fmtPeriodo(periodoAnterior.start, periodoAnterior.end)}</span>.
                                    </span>
                                )}
                            </p>
                        </div>

                        {/* Date range picker */}
                        <div className="surface-card flex items-center gap-2 p-1.5 self-start md:self-auto">
                            <span className="px-2 grid place-items-center text-ink-4">
                                <CalendarDays className="h-4 w-4" />
                            </span>
                            <DateInput
                                label="De"
                                value={dateRange.start}
                                onChange={(v) => handleDateChange('start', v)}
                            />
                            <div className="h-5 w-px bg-white/10" />
                            <DateInput
                                label="Até"
                                value={dateRange.end}
                                onChange={(v) => handleDateChange('end', v)}
                            />
                        </div>
                    </header>

                    {/* KPI bento */}
                    <DataResume />

                    {/* Charts bento */}
                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 mb-4">
                        <GraphicProductMain />
                        <GraphicOrderbump />
                    </div>

                    <div className="grid grid-cols-1 gap-4">
                        <GraphicDailySales />
                    </div>

                </div>
            </div>
        </div>
    );
}


function DateInput({ label, value, onChange }) {
    return (
        <label className="flex items-center gap-2 px-2 py-1 group cursor-pointer">
            <span className="text-2xs uppercase tracking-wider font-medium text-ink-4 group-hover:text-ink-3 transition">
                {label}
            </span>
            <input
                type="date"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="bg-transparent text-sm text-ink-1 font-medium tabular-nums cursor-pointer focus:text-brand-300 transition-colors"
            />
        </label>
    );
}
